import ethocaMinnaTechLogo from '@cancellation-portal/assets/images/ethoca-minna-tech-logo.svg';
import ethocaMinnaTechWhiteLogo from '@cancellation-portal/assets/images/ethoca-minna-tech-white-logo.svg';
import type { AppContext } from '../modules/app-context';
import { AppType, Locale, Market } from '../modules/app-context/constants';

// cancellation-portal only
export const getLogo = (): string => {
  return ethocaMinnaTechLogo;
};

export const getLogoAltText = ({
  appType,
  locale,
  market,
}: Pick<AppContext, 'appType' | 'locale' | 'market'>): string => {
  const englishName = 'Minna Tech';
  const swedishName = 'Minatjänster.se';

  if (locale === Locale.enGB) {
    return englishName;
  }

  switch (appType) {
    case AppType.Standalone:
    case AppType.DanskeBank:
    case AppType.Swedbank:
      return swedishName;
    case AppType.CancellationPortal:
      return market === Market.Sweden ? swedishName : englishName;

    default:
      return englishName;
  }
};

export const getWhiteLogo = (): string => {
  return ethocaMinnaTechWhiteLogo;
};
